var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tttest",staticClass:"data-grid__col",style:({width: _vm.size === 'auto' ? 'auto' : _vm.size + '%'}),attrs:{"data-title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }